import * as Sentry from '@sentry/react';

/**
 * Initialise Sentry only in production builds. Local `pnpm dev` keeps the
 * console clean and avoids leaking dev-server traces to the Frankfurt project.
 * Gated per [PLAN.md Phase 1](../../../PLAN.md).
 */
export function initSentry(): void {
  if (!import.meta.env.PROD) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    console.warn('[sentry] VITE_SENTRY_DSN not set — skipping init');
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_GIT_SHA,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
